const isDisabled = (value) => typeof value === 'string' && value.trim().toLowerCase() === 'false';

export const APPLICATION_FORM_ENABLED = !isDisabled(process.env.REACT_APP_ENABLE_WAITLIST);
export const WEATHER_STATION_ENABLED = !isDisabled(process.env.REACT_APP_ENABLE_WEATHER_STATION);
